
import { NgModule } from '@angular/core';
import { HttpModule, XHRBackend, RequestOptions, Http } from '@angular/http';
import { AppModuleConstants } from './app-module.constants';
import { HttpService } from './shared/Utils/http.service';
import { AppComponent } from './app.component';
import { AppService } from './app.service';
import { CookieService } from 'angular2-cookie/core';
import { BrowserXhr } from '@angular/http';
import { NgProgressBrowserXhr } from 'ngx-progressbar';
import { UrlSerializer } from '@angular/router';
import { LowerCaseUrlSerializer } from './shared/Utils/LowerCaseUrlSerializer';
import { AppLoaderService } from './shared/services/app-loader.service';
import { OwlDateTimeModule, OWL_DATE_TIME_LOCALE, OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import { OwlMomentDateTimeModule } from 'ng-pick-datetime-moment';
import { Title } from '@angular/platform-browser';


export function httpServiceFactory(backend: XHRBackend, defaultOptions: RequestOptions) {
	return new HttpService(backend, defaultOptions);
}

export const MY_MOMENT_FORMATS = {
	parseInput: 'MMM YYYY',
	fullPickerInput: 'l LT',
	datePickerInput: 'DD-MMM-YYYY',
	timePickerInput: 'LT',
	monthYearLabel: 'MMM YYYY',
	dateA11yLabel: 'LL',
	monthYearA11yLabel: 'MMMM YYYY',
};

@NgModule({
	imports: [AppModuleConstants.MODULE_IMPORTS],
	declarations: AppModuleConstants.MODULE_DECLARATIONS,
	providers: [Title, AppLoaderService, {
		provide: Http,
		useFactory: httpServiceFactory,
		// deps: [XHRBackend, RequestOptions, LoaderService]
		deps: [XHRBackend, RequestOptions]
	},
		{ provide: BrowserXhr, useClass: NgProgressBrowserXhr },
		AppService, CookieService, { provide: UrlSerializer, useClass: LowerCaseUrlSerializer },
		{ provide: OWL_DATE_TIME_LOCALE, useValue: 'en' },
		{ provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS }],
	bootstrap: [AppComponent]
})
export class AppModule {

}



// WEBPACK FOOTER //
// ./src/app/app.module.ts